module.exports = __webpack_public_path__ + "img/8.dad0c933.jpg";